import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Accordion, AccordionItem, AccordionHeader, AccordionDetail, AccordionTitle } from '@vds/accordions';
import { useSelector, shallowEqual } from 'react-redux';
import { Button } from '@vds/buttons';
import { selectStateCache } from '../@selectors';
import { selectStateCache as selectCheckoutStateCache } from '../../@Redux/selectors/checkout.selectors';
import { Title, Micro } from '../../../common/Typography/index';
import './desktopCart.css';
import DueTodayProduct from './dueTodayProduct';
import DueMonthlyProduct from './dueMonthlyProduct';
import NextBillSummary from '../../ExpressCheckout/Components/NextBillSummary';
import PromoCode from '../PromoCode';
import { useMiniCartHooks } from '../@Redux/OrderSummary.hooks';
import { priceFormat } from '../../../common/Helpers';
import { Margin } from '../../../common/styles';
import { checkoutLabels } from '../../ExpressCheckout/Components/labels';

const DesktopCart = (props) => {
  const { clickPromo } = props;
  const stateCacheCart = useSelector((state) => selectStateCache(state), shallowEqual);
  const stateCacheCheckout = useSelector((state) => selectCheckoutStateCache(state), shallowEqual);
  const { dueAmount } = useMiniCartHooks(stateCacheCart, stateCacheCheckout);
  const { dueTodayAmount, dueMonthlyAmount, subtitleText } = dueAmount || {};
  const [showOpenView, setShowOpenView] = useState(true);

  const cqlabels = window?.checkoutCQ?.output?.checkoutLabels ? window?.checkoutCQ?.output?.checkoutLabels : checkoutLabels;

  const redirect5Ghome = () => {
    setShowOpenView(!showOpenView);
  };

  const contiueBtnclk = () => {
    // alert('dddddddd');
    props.callBtnMethod();
  };
  return (
    <>
      <div className="orderSummaryContainer">
        <Title size="medium" bold>
          Order summary
        </Title>
        <Margin top="16px" bottom="16px">
          <div className="titleContainer">
            <div className="scrollContainer">
              <Accordion type="multi" bottomLine={false}>
                <AccordionItem opened={showOpenView}>
                  <AccordionHeader
                    trigger={{
                      id: 'dueTodayHeader',
                      type: 'icon',
                      onClick: () => {
                        redirect5Ghome();
                      },
                    }}
                  >
                    <AccordionTitle bold>
                      <div className="headNamePrice">
                        <Title color="black" size="TitleSmall" bold>
                          Due today
                        </Title>
                        <div>{priceFormat(dueTodayAmount)}</div>
                      </div>
                    </AccordionTitle>
                      {subtitleText && (
                        <Micro size="large" color="#6F7171">
                          {subtitleText}
                        </Micro>
                      )}
                  </AccordionHeader>
                  <AccordionDetail opened={showOpenView}>
                    <DueTodayProduct />
                  </AccordionDetail>
                  <AccordionTitle bold>
                    <div className="headNamePrice">
                      <Title color="black" size="TitleSmall" bold>
                        Due monthly for 5G Home
                      </Title>
                      <div>{priceFormat(dueMonthlyAmount)}</div>
                    </div>
                  </AccordionTitle>
                  <Margin top="30px" className="dueMonthlySection">
                    <AccordionDetail opened={showOpenView}>
                      <DueMonthlyProduct />
                    </AccordionDetail>
                    {props?.pageName && props?.pageName === 'expresscheckout' && (
                      <AccordionDetail opened={showOpenView}>
                        <NextBillSummary pageName="expresscheckout" {...cqlabels} />
                        <PromoCode onClickPromo={clickPromo} />
                      </AccordionDetail>
                    )}
                    {props.btnName && (
                      <Button ariaLabel="continue" size="large" width="100%" primary onClick={() => contiueBtnclk()}>
                        {props.btnName}
                      </Button>
                    )}
                  </Margin>
                </AccordionItem>
              </Accordion>
            </div>
          </div>
        </Margin>
      </div>
    </>
  );
};

DesktopCart.propTypes = {
  pageName: PropTypes.string,
  btnName: PropTypes.string,
  callBtnMethod: PropTypes.func,
  clickPromo: PropTypes.func,
};

export default DesktopCart;
